import Base from '../Base';
import { Prop, Component } from 'vue-property-decorator';
import { Button } from 'streamlabs-beaker';

type TArrowPosition =
  | 'top-left'
  | 'top-center'
  | 'top-right'
  | 'bottom-left'
  | 'bottom-center'
  | 'bottom-right';

@Component({
  components: {
    SButton: Button,
  },
})
export default class Tooltip extends Base {
  @Prop({ required: false, default: '' })
  title: string;

  @Prop({ required: false, default: '' })
  description: string;

  @Prop({ default: 'Got it!' })
  buttonTitle!: string;

  @Prop({ default: 200 })
  width: number;

  @Prop({ default: 'top-center' })
  arrowPosition: TArrowPosition;

  @Prop({ default: 0 })
  totalSteps: number;

  @Prop({ default: null })
  currentStep: number;

  clickHandler() {
    this.$emit('handle-tooltip');
  }

  secondaryClickHandler() {
    this.$emit('secondary-handle-tooltip');
  }

  get arrowClass() {
    let classes: string[] = [];

    if (this.arrowPosition) {
      classes.push(`tooltip__arrow--${this.arrowPosition}`);
    }

    return classes;
  }

  get tooltipDirectionClass() {
    let classes: string[] = [];

    if (this.arrowPosition) {
      classes.push(`tooltip--${this.arrowPosition}`);
    }

    return classes;
  }
}
